<template>
  <div
    class="absolute z-[6] pointer-events-none origin-top-left duration-700 transition-[left,top]"
    :style="style"
  >
    <MousePointer2
      class="size-4 drop-shadow-[1px_1px_1px_rgba(0,0,0,0.5)]"
      :fill="color"
      :color="color"
    />
    <div
      class="rounded-md p-[0px_6px_1px] text-[11px] text-white mt-0 ml-4 whitespace-nowrap"
      :style="{ background: color }"
    >
      {{ name }}
    </div>
  </div>
</template>

<script setup>
import { MousePointer2 } from 'lucide-vue-next';
import { computed } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: null,
  },
  boardPos: {
    type: Object,
    default: null,
  },
  name: {
    type: String,
    default: null,
  },
  scale: {
    type: Number,
    default: 1,
  },
  transform: {
    type: Number,
    default: null,
  },
});

const style = computed(() => {
  const newScale = 1 / props.scale;
  return {
    transform: `scale(${newScale})`,
    left: `${props.boardPos.x}px`,
    top: `${props.boardPos.y}px`,
  };
});
</script>
